export default __webpack_public_path__ + "static/media/File No. 9.2262c454.pdf";